import SubheaderTabs from './subheader-tabs'

export default SubheaderTabs
